/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/links',
  name: 'Links',
  component: () => import('@/views/links/Index'),



},
{
  path: '/noor',
  name: 'Noor',
  component: () => import('@/views/links/Noor'),



}]
